import React, { useCallback, useEffect } from "react";
import Routes from "routes/Index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "styles/reset/reset.scss";
import "styles/general/header.scss";
import "styles/general/spacer.scss";
import "styles/g-grid-v2/g-grid.scss";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import { getCurrentUser, selectState } from "authentication/main.slice";
import { getProvision } from "Dashboard/dashboard.slice";
import { useAuth } from "react-oidc-context";
import { authServices } from "authentication/services/auth.service";
import Loader from "components/Loader/Loader";
import ServerError from "components/ServerError";
import { useIdleLogout } from "hooks/useIdleLogout";
import config from "config/Config";

function App() {
  const auth = useAuth();
  if (
    auth.isAuthenticated &&
    auth.user &&
    auth.user.profile &&
    auth.user.profile.preferred_username
  ) {
    authServices.login(
      auth.user?.profile?.preferred_username,
      auth.user?.access_token
    );
  }

  const dispatch = useAppDispatch();
  const { user, userFetched, userError } = useSelector(selectState);

  useEffect(() => {
    dispatch(getCurrentUser());
    if (auth.isAuthenticated) {
      dispatch(getProvision());
    }
  }, [dispatch, auth.isAuthenticated]);

  const onIdle = useCallback(() => {
    authServices.logout();
    auth.signoutRedirect({ post_logout_redirect_uri: config.HOME_URL });
  }, [auth]);

  useIdleLogout(
    config.INACTIVITY_TIMEOUT_MINUTES * 60 * 1000,
    onIdle,
    auth.isAuthenticated
  );

  return (
    <div className="App">
      {userFetched && <Routes user={user} />}
      {!userFetched && <Loader />}
      {userError && <ServerError />}
      <ToastContainer
        position="bottom-right"
        hideProgressBar={true}
        autoClose={2000}
      />
    </div>
  );
}

export default App;
